/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Spaces and line breaks are ignored on decode; the binary just needs to be a multiple of 8 bits made only of 0s and 1s.`)
};

const es_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Los espacios y saltos de línea se ignoran al decodificar; el binario solo necesita ser un múltiplo de 8 bits hecho solo de 0s y 1s.`)
};

const de_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Leerzeichen und Zeilenumbrüche werden beim Dekodieren ignoriert; der Binärcode muss lediglich ein Vielfaches von 8 Bit sein und nur aus 0 und 1 bestehen.`)
};

const nl_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Spaties en regelafbrekingen worden genegeerd bij decodering; het binair moet alleen een veelvoud van 8 bits zijn gemaakt van 0en en 1en.`)
};

const fr_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les espaces et les sauts de ligne sont ignorés lors du décodage; le binaire doit simplement être un multiple de 8 bits composés uniquement de 0 et 1.`)
};

const it_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Gli spazi e le interruzioni di riga vengono ignorati durante la decodifica; il binario deve solo essere un multiplo di 8 bit composto solo da 0 e 1.`)
};

const pt_br2_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Espaços e quebras de linha são ignorados na decodificação; o binário apenas precisa ser um múltiplo de 8 bits composto apenas de 0s e 1s.`)
};

const pt_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Espaços e quebras de linha são ignorados na descodificação; o binário apenas precisa ser um múltiplo de 8 bits feito apenas de 0s e 1s.`)
};

const ja_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。デコード時に空白と改行は無視されます。バイナリは 0 と 1 のみで構成された 8 ビットの倍数である必要があります。`)
};

const zh_tb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。解码时空格和换行符都会被忽略;二进制只需要是仅由0和1组成、且位数为8的倍数即可。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq2_a", locale)
	if (locale === "en") return en_tb_faq2_a(inputs)
	if (locale === "es") return es_tb_faq2_a(inputs)
	if (locale === "de") return de_tb_faq2_a(inputs)
	if (locale === "nl") return nl_tb_faq2_a(inputs)
	if (locale === "fr") return fr_tb_faq2_a(inputs)
	if (locale === "it") return it_tb_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq2_a(inputs)
	if (locale === "pt") return pt_tb_faq2_a(inputs)
	if (locale === "ja") return ja_tb_faq2_a(inputs)
	return zh_tb_faq2_a(inputs)
};